(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["suppdawg-bite-down-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      document.querySelectorAll('[data-sd-bite-gallery]').forEach((gallery) => {
        if (gallery.dataset.ready === 'true') return;
        const main = gallery.querySelector('[data-gallery-main]');
        const rail = gallery.querySelector('[data-gallery-rail]');
        const factsLink = gallery.querySelector('[data-gallery-facts-link]');
        const variantData = gallery.querySelector('[data-gallery-variants]');
        const sectionId = gallery.closest('[data-section]')?.dataset.section;
        if (!main || !rail || !variantData) return;
        let variants;
        try { variants = JSON.parse(variantData.textContent); } catch { return; }
        gallery.dataset.ready = 'true';
        const items = [...rail.querySelectorAll('[data-gallery-item]')];
        const slots = items.filter((item) => item.dataset.gallerySlot);
        let active = items.find((item) => item.getAttribute('aria-pressed') === 'true');
        let currentVariantId = String(gallery.dataset.variantId);
        let touchStart = null;
        const visibleItems = () => items.filter((item) => !item.hidden && item.dataset.src);
        const show = (item, scroll = true) => {
          if (!item || item.hidden || !item.dataset.src) return;
          active = item;
          main.hidden = false;
          if (item.dataset.srcset) main.setAttribute('srcset', item.dataset.srcset);
          else main.removeAttribute('srcset');
          main.src = item.dataset.src;
          main.alt = item.dataset.alt || '';
          main.width = Number(item.dataset.width) || 1200;
          main.height = Number(item.dataset.height) || 1200;
          main.classList.toggle('is-contain', item.dataset.contain === 'true');
          main.classList.toggle('is-studio', item.dataset.gallerySlot === 'studio');
          items.forEach((candidate) => {
            const selected = candidate === item;
            candidate.classList.toggle('is-active', selected);
            candidate.setAttribute('aria-pressed', String(selected));
          });
          if (factsLink) {
            factsLink.hidden = item.dataset.gallerySlot !== 'facts';
            if (!factsLink.hidden) {
              factsLink.href = item.dataset.src;
              factsLink.textContent = item.dataset.linkLabel || item.dataset.alt;
            }
          }
          if (scroll && rail.scrollWidth > rail.clientWidth) {
            rail.scrollTo({
              left: Math.max(0, item.offsetLeft - ((rail.clientWidth - item.offsetWidth) / 2)),
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        };
        const clearSelectedVariant = () => {
          slots.forEach((item) => { item.hidden = true; });
          items.forEach((item) => { item.setAttribute('aria-pressed', 'false'); item.classList.remove('is-active'); });
          main.hidden = true;
          main.removeAttribute('src');
          main.removeAttribute('srcset');
          main.alt = '';
          if (factsLink) factsLink.hidden = true;
          active = null;
        };
        const setVariant = (variantId, force = false) => {
          const id = String(variantId);
          if (!force && id === currentVariantId) return;
          currentVariantId = id;
          gallery.dataset.variantId = id;
          if (!Object.prototype.hasOwnProperty.call(variants, id)) {
            clearSelectedVariant();
            return;
          }
          const variant = variants[id];
          slots.forEach((item) => {
            const image = variant[item.dataset.gallerySlot];
            item.hidden = !image || !image.src;
            item.dataset.src = image?.src || '';
            item.dataset.srcset = image?.srcset || '';
            item.dataset.alt = image?.alt || '';
            item.dataset.width = image?.width || 1200;
            item.dataset.height = image?.height || 1200;
            item.dataset.linkLabel = image?.linkLabel || '';
            item.setAttribute('aria-label', image?.alt || '');
            item.querySelectorAll('[data-gallery-flavor]').forEach((label) => { label.textContent = variant.flavor; });
            const thumbnail = item.querySelector('img');
            if (thumbnail) {
              if (image?.thumbset) thumbnail.setAttribute('srcset', image.thumbset);
              else thumbnail.removeAttribute('srcset');
              if (image?.thumb) thumbnail.src = image.thumb;
              else thumbnail.removeAttribute('src');
            }
          });
          const studio = slots.find((item) => item.dataset.gallerySlot === 'studio' && !item.hidden);
          const front = slots.find((item) => item.dataset.gallerySlot === 'front' && !item.hidden);
          if (studio || front) show(studio || front, false);
          else clearSelectedVariant();
        };
        const step = (direction) => {
          const visible = visibleItems();
          if (!visible.length) return;
          const index = visible.indexOf(active);
          show(visible[(index + direction + visible.length) % visible.length]);
        };
        items.forEach((item) => item.addEventListener('click', () => show(item)));
        gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => step(-1));
        gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => step(1));
        const hero = gallery.querySelector('.sd-bite-gallery__hero');
        hero?.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
        hero?.addEventListener('touchend', (event) => {
          if (touchStart === null || !event.changedTouches[0]) return;
          const distance = event.changedTouches[0].clientX - touchStart;
          touchStart = null;
          if (Math.abs(distance) > 45) step(distance < 0 ? 1 : -1);
        }, { passive: true });
        document.addEventListener('change', (event) => {
          if (!gallery.isConnected || !sectionId) return;
          const target = event.target;
          if (!target || typeof target.matches !== 'function' || !target.matches('input[name="id"]')) return;
          const formId = target.form?.getAttribute('id');
          if (formId !== 'product-form-' + sectionId && formId !== 'sticky-addcart-form-' + sectionId) return;
          setVariant(target.value);
        });
        setVariant(currentVariantId, true);
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["suppdawg-buff-current-facts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-sd-buff-facts-thumb]') : null;
    if (!button) return;
    const gallery = button.closest('slide-with-thumbs');
    const wrapper = button.parentElement;
    if (!gallery || !wrapper || !gallery.globalSlide || typeof gallery.functionGoto !== 'function') return;
    const index = Array.from(wrapper.children).filter((element) => element.classList.contains('swiper-slide')).indexOf(button);
    if (index >= 0) gallery.functionGoto(index);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["suppdawg-bundle-price-labels"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sd-bundle-price-labels')) {
    customElements.define('sd-bundle-price-labels', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById(this.dataset.sectionId);
        if (!this.root) return;
        this.update = () => {
          this.frame = null;
          this.root.querySelectorAll('.kaching-bundles__bar').forEach((bar) => {
            const title = bar.querySelector('.kaching-bundles__bar-title')?.textContent.trim() || '';
            if (!/^(?:2\s+tubs|pack\s+of\s+2\b)/i.test(title)) return;
            const badge = bar.querySelector('.kaching-bundles__bar-most-popular__content');
            if (!badge) return;
            let label = this.dataset.fallback;
            const original = this.parseUsd(bar.querySelector('.kaching-bundles__bar-full-price')?.textContent);
            const current = this.parseUsd(bar.querySelector('.kaching-bundles__bar-price')?.textContent);
            if (this.dataset.currency === 'USD' && original !== null && current !== null && original > current) {
              const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
                style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2
              }).format((original - current) / 100);
              label = this.dataset.savingTemplate.replace('[amount]', amount);
            }
            if (label && badge.textContent.trim() !== label) badge.textContent = label;
          });
        };
        this.schedule = () => {
          if (this.frame == null) this.frame = requestAnimationFrame(this.update);
        };
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.root, { childList: true, subtree: true, characterData: true });
        this.update();
      }
      parseUsd(value) {
        const normalized = String(value || '').replace(/[\u200e\u200f\u2066-\u2069]/g, '').trim();
        const match = normalized.match(/^(?:US)?\$\s*(\d{1,3}(?:,\d{3})*|\d+)(?:\.(\d{2}))?$/);
        return match ? Number(match[1].replace(/,/g, '')) * 100 + Number(match[2] || 0) : null;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame != null) cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["suppdawg-guide-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const link = event.target.closest && event.target.closest('a[data-guide-product]');
  if (!link) return;
  const privacy = window.Shopify && window.Shopify.customerPrivacy;
  if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
  const analytics = window.Shopify && window.Shopify.analytics;
  if (!analytics || typeof analytics.publish !== 'function') return;
  try {
    Promise.resolve(analytics.publish('suppdawg:guide_product_click', {
      article_handle: link.dataset.guideOwner,
      product_handle: link.dataset.guideProduct,
      placement: 'answer_first_pilot'
    })).catch(function() {});
  } catch (error) {}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["suppdawg-ordered-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sd-ordered-gallery')) {
    class SuppDawgOrderedGallery extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => {
          if (!this.isConnected) return;
          this.abort?.abort();
          this.abort = new AbortController();
          this.view = this.querySelector('[data-sd-gallery-view]');
          this.status = this.querySelector('[data-sd-gallery-status]');
          this.count = this.querySelector('[data-sd-gallery-count]');
          this.controls = this.querySelector('[data-sd-gallery-controls]');
          this.empty = this.querySelector('[data-sd-gallery-empty]');
          if (!this.view || !this.status) return;
          this.currentVariant = String(this.dataset.variantId);
          this.index = 0;
          this.touchStart = null;
          const options = { signal: this.abort.signal };
          this.addEventListener('click', event => {
            const item = event.target.closest('[data-sd-gallery-go]');
            if (item && this.contains(item)) {
              const index = this.panels.findIndex(panel => panel.id === item.dataset.sdGalleryGo);
              if (index >= 0) this.show(index, true);
              return;
            }
            const direction = event.target.closest('[data-sd-gallery-direction]');
            if (direction && this.contains(direction)) this.step(Number(direction.dataset.sdGalleryDirection));
          }, options);
          this.addEventListener('keydown', event => {
            const item = event.target.closest('[data-sd-gallery-go]');
            if (!item || !this.contains(item)) return;
            let next;
            if (event.key === 'ArrowRight') next = this.index + 1;
            else if (event.key === 'ArrowLeft') next = this.index - 1;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.panels.length - 1;
            else return;
            event.preventDefault();
            this.show(next, true);
            this.buttons[this.index]?.focus({ preventScroll: true });
          }, options);
          this.addEventListener('touchstart', event => {
            const panel = event.target.closest('[data-sd-gallery-panel]');
            if (!panel || panel.dataset.role === 'facts') return;
            const touch = event.changedTouches[0];
            this.touchStart = touch ? { x: touch.clientX, y: touch.clientY } : null;
          }, { ...options, passive: true });
          this.addEventListener('touchend', event => {
            const touch = event.changedTouches[0], start = this.touchStart;
            this.touchStart = null;
            if (!touch || !start) return;
            const x = touch.clientX - start.x, y = touch.clientY - start.y;
            if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.5) this.step(x < 0 ? 1 : -1);
          }, { ...options, passive: true });
          document.addEventListener('change', event => {
            const target = event.target;
            if (!target?.matches?.('input[name="id"], select[name="id"]')) return;
            const formId = target.form?.getAttribute('id'), sectionId = this.dataset.sectionId;
            if (formId !== 'product-form-' + sectionId && formId !== 'sticky-addcart-form-' + sectionId) return;
            this.setVariant(String(target.value));
          }, options);
          this.refresh();
          this.classList.add('is-ready');
        });
      }
      disconnectedCallback() { this.abort?.abort(); }
      refresh() {
        this.panels = [...this.view.querySelectorAll('[data-sd-gallery-panel]')];
        this.buttons = [...this.view.querySelectorAll('[data-sd-gallery-go]')];
        this.querySelectorAll('[data-sd-gallery-direction]').forEach(button => { button.disabled = this.panels.length < 2; });
        this.show(0, false);
      }
      setVariant(id) {
        if (id === this.currentVariant) return;
        this.currentVariant = id;
        this.dataset.variantId = id;
        const template = [...this.querySelectorAll('template[data-sd-gallery-template]')].find(item => item.dataset.variantId === id);
        if (!template) {
          this.view.hidden = true;
          this.controls.hidden = true;
          if (this.empty) this.empty.hidden = false;
          return;
        }
        this.view.replaceChildren(template.content.cloneNode(true));
        this.view.hidden = false;
        this.controls.hidden = false;
        if (this.empty) this.empty.hidden = true;
        this.refresh();
      }
      step(direction) { this.show(this.index + direction, true); }
      show(index, scroll) {
        if (!this.panels?.length) return;
        this.index = (index + this.panels.length) % this.panels.length;
        this.panels.forEach((panel, i) => { panel.hidden = i !== this.index; });
        this.buttons.forEach((button, i) => {
          const active = i === this.index;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        if (this.count) this.count.textContent = String(this.index + 1) + ' / ' + String(this.panels.length);
        this.status.textContent = (this.dataset.positionLabel || '__CURRENT__ / __TOTAL__')
          .replace('__CURRENT__', String(this.index + 1))
          .replace('__TOTAL__', String(this.panels.length))
          .replace('__NAME__', this.panels[this.index].dataset.label || '');
        if (scroll) {
          requestAnimationFrame(() => {
            const activePanel = this.panels[this.index];
            if (!activePanel || !this.isConnected) return;
            const rect = activePanel.getBoundingClientRect();
            if (rect.top < 0 && rect.bottom < window.innerHeight * 0.5) {
              activePanel.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            }
          });
        }
        const activeButton = this.buttons[this.index], rail = activeButton?.parentElement;
        if (scroll && rail && rail.scrollWidth > rail.clientWidth) {
          rail.scrollTo({
            left: Math.max(0, activeButton.offsetLeft - rail.offsetLeft - ((rail.clientWidth - activeButton.offsetWidth) / 2)),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        }
      }
    }
    customElements.define('sd-ordered-gallery', SuppDawgOrderedGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["suppdawg-shock-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      document.querySelectorAll('[data-sd-shock-gallery]').forEach((gallery) => {
        if (gallery.dataset.ready === 'true') return;
        const main = gallery.querySelector('[data-gallery-main]');
        const rail = gallery.querySelector('[data-gallery-rail]');
        const factsLink = gallery.querySelector('[data-gallery-facts-link]');
        const variantData = gallery.querySelector('[data-gallery-variants]');
        const sectionId = gallery.closest('[data-section]')?.dataset.section;
        if (!main || !rail || !variantData) return;
        let variants;
        try { variants = JSON.parse(variantData.textContent); } catch { return; }
        gallery.dataset.ready = 'true';
        const items = [...rail.querySelectorAll('[data-gallery-item]')];
        const slots = items.filter((item) => item.dataset.gallerySlot);
        let active = items.find((item) => item.getAttribute('aria-pressed') === 'true');
        let currentVariantId = String(gallery.dataset.variantId);
        let touchStart = null;
        const visibleItems = () => items.filter((item) => !item.hidden && item.dataset.src);
        const show = (item, scroll = true) => {
          if (!item || item.hidden || !item.dataset.src) return;
          active = item;
          main.hidden = false;
          if (item.dataset.srcset) main.setAttribute('srcset', item.dataset.srcset);
          else main.removeAttribute('srcset');
          main.src = item.dataset.src;
          main.alt = item.dataset.alt || '';
          main.width = Number(item.dataset.width) || 1200;
          main.height = Number(item.dataset.height) || 1200;
          main.classList.toggle('is-contain', item.dataset.contain === 'true');
          main.classList.toggle('is-studio', item.dataset.gallerySlot === 'studio');
          items.forEach((candidate) => {
            const selected = candidate === item;
            candidate.classList.toggle('is-active', selected);
            candidate.setAttribute('aria-pressed', String(selected));
          });
          if (factsLink) {
            factsLink.hidden = item.dataset.gallerySlot !== 'facts';
            if (!factsLink.hidden) {
              factsLink.href = item.dataset.src;
              factsLink.textContent = item.dataset.linkLabel || item.dataset.alt;
            }
          }
          if (scroll && rail.scrollWidth > rail.clientWidth) {
            rail.scrollTo({
              left: Math.max(0, item.offsetLeft - ((rail.clientWidth - item.offsetWidth) / 2)),
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          }
        };
        const clearSelectedVariant = () => {
          slots.forEach((item) => { item.hidden = true; });
          items.forEach((item) => { item.setAttribute('aria-pressed', 'false'); item.classList.remove('is-active'); });
          main.hidden = true;
          main.removeAttribute('src');
          main.removeAttribute('srcset');
          main.alt = '';
          if (factsLink) factsLink.hidden = true;
          active = null;
        };
        const setVariant = (variantId, force = false) => {
          const id = String(variantId);
          if (!force && id === currentVariantId) return;
          currentVariantId = id;
          gallery.dataset.variantId = id;
          if (!Object.prototype.hasOwnProperty.call(variants, id)) {
            clearSelectedVariant();
            return;
          }
          const variant = variants[id];
          slots.forEach((item) => {
            const image = variant[item.dataset.gallerySlot];
            item.hidden = !image || !image.src;
            item.dataset.src = image?.src || '';
            item.dataset.srcset = image?.srcset || '';
            item.dataset.alt = image?.alt || '';
            item.dataset.width = image?.width || 1200;
            item.dataset.height = image?.height || 1200;
            item.dataset.linkLabel = image?.linkLabel || '';
            item.setAttribute('aria-label', image?.alt || '');
            item.querySelectorAll('[data-gallery-flavor]').forEach((label) => { label.textContent = variant.flavor; });
            const thumbnail = item.querySelector('img');
            if (thumbnail) {
              if (image?.thumbset) thumbnail.setAttribute('srcset', image.thumbset);
              else thumbnail.removeAttribute('srcset');
              if (image?.thumb) thumbnail.src = image.thumb;
              else thumbnail.removeAttribute('src');
            }
          });
          const studio = slots.find((item) => item.dataset.gallerySlot === 'studio' && !item.hidden);
          const front = slots.find((item) => item.dataset.gallerySlot === 'front' && !item.hidden);
          if (studio || front) show(studio || front, false);
          else clearSelectedVariant();
        };
        const step = (direction) => {
          const visible = visibleItems();
          if (!visible.length) return;
          const index = visible.indexOf(active);
          show(visible[(index + direction + visible.length) % visible.length]);
        };
        items.forEach((item) => item.addEventListener('click', () => show(item)));
        gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => step(-1));
        gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => step(1));
        const hero = gallery.querySelector('.sd-shock-gallery__hero');
        hero?.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
        hero?.addEventListener('touchend', (event) => {
          if (touchStart === null || !event.changedTouches[0]) return;
          const distance = event.changedTouches[0].clientX - touchStart;
          touchStart = null;
          if (Math.abs(distance) > 45) step(distance < 0 ? 1 : -1);
        }, { passive: true });
        document.addEventListener('change', (event) => {
          if (!gallery.isConnected || !sectionId) return;
          const target = event.target;
          if (!target || typeof target.matches !== 'function' || !target.matches('input[name="id"]')) return;
          const formId = target.form?.getAttribute('id');
          if (formId !== 'product-form-' + sectionId && formId !== 'sticky-addcart-form-' + sectionId) return;
          setVariant(target.value);
        });
        setVariant(currentVariantId, true);
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["suppdawg-studio-gallery-slide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-sd-studio-thumbnail]') : null;
    if (!button) return;
    const gallery = button.closest('slide-with-thumbs');
    if (gallery && gallery.globalSlide && typeof gallery.functionGoto === 'function') {
      gallery.functionGoto(0);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
